import React from 'react';
import { Link } from 'react-router-dom';
import styled from 'styled-components';

const SidebarContainer = styled.div`
  width: 250px;
  background-color: #7e22ce;
  color: white;
  padding: 2rem 1rem;
  min-height: 100vh;
`;

const SidebarTitle = styled.h2`
  margin-bottom: 2rem;
  text-align: center;
`;

const NavList = styled.ul`
  list-style: none;
  padding: 0;
`;

const NavItem = styled.li`
  margin-bottom: 1rem;
`;

const NavLink = styled(Link)`
  color: white;
  text-decoration: none;
  display: block;
  padding: 0.5rem;
  border-radius: 0.25rem;
  transition: background-color 0.3s;

  &:hover {
    background-color: rgba(255, 255, 255, 0.1);
  }
`;

const Sidebar: React.FC = () => {
  return (
    <SidebarContainer>
      <SidebarTitle>Content Creator</SidebarTitle>
      <NavList>
        <NavItem>
          <NavLink to="/content-creator/dashboard">Dashboard</NavLink>
        </NavItem>
        <NavItem>
          <NavLink to="/content-creator/profile">Profile</NavLink>
        </NavItem>
        <NavItem>
          <NavLink to="/content-creator/submissions">Submissions</NavLink>
        </NavItem>
        <NavItem>
          <NavLink to="/content-creator/earnings">Earnings</NavLink>
        </NavItem>
      </NavList>
    </SidebarContainer>
  );
};

export default Sidebar; 